import React, { useState } from "react";
import { EditorState, RichUtils } from "draft-js";

import { Input } from "../../../../form/Input";
import { Button } from "../../../../button/Button/Button";
import { Checkbox } from "../../../../form/Checkbox";
import { Row } from "../../../../grid/Row";
import { Col } from "../../../../grid/Col";
import { hasEntity, getCurrentEntity } from "../../utils";
import styles from "./LinkEdit.scss";

export const LinkEdit = ({ editorState, onChange, setEditingEntity }) => {
    const entityType = "LINK";
    const currentEntity = hasEntity(editorState, entityType) ? getCurrentEntity(editorState) : null;
    const data = currentEntity ? currentEntity.getData() : null;

    const [url, setUrl] = useState(data ? data.url : "");
    const [targetOption, setTargetOption] = useState(data ? data.targetOption : null);
    const [error, setError] = useState(false);

    /**
     * Set link value
     * @private
     */
    const handleSetLink = () => {
        // Check if url
        if (!url || url.trim() === "") {
            return handleRemoveLink();
        }

        // Add protocol
        if (!url.startsWith("http://") && !url.startsWith("https://")) {
            setUrl(`http://${url}`);
        }

        // Validate url
        const expression =
            /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/gi;
        const regex = new RegExp(expression);
        if (!url.match(regex)) {
            setError(true);
        }

        // Get the entire content block
        const contentState = editorState.getCurrentContent();

        // Create entity around content block
        const contentStateWithEntity = contentState.createEntity(entityType, "MUTABLE", {
            url,
            targetOption
        });

        // Get entity key
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

        // Toggle link
        let newState = RichUtils.toggleLink(editorState, editorState.getSelection(), entityKey);

        // Set selection to markup again
        const selectionState = EditorState.forceSelection(newState, editorState.getSelection());

        // Hide action
        setEditingEntity(null);

        // Handle change
        onChange(selectionState);
    };

    const handleRemoveLink = () => {
        // Get current selection
        const selection = editorState.getSelection();
        if (!selection.isCollapsed()) {
            // New state
            const newState = RichUtils.toggleLink(editorState, selection, null);

            setEditingEntity(null);
            onChange(newState);
        }
    };

    return (
        <div className={styles.base}>
            <Row gutter={["small", "small"]}>
                <Col grow>
                    <Input autoFocus={true} size="small" value={url} error={error} placeholder="http://..." onChange={setUrl} />
                </Col>
                <Col>
                    <Button size="small" square icon="check" color="primary" onClick={handleSetLink} />
                </Col>
                <Col grow align={["center", "center"]}>
                    <Checkbox
                        checked={targetOption === "blank"}
                        onChange={() => setTargetOption(targetOption === "blank" ? null : "blank")}
                    >
                        Åpne lenke i nytt vindu
                    </Checkbox>
                </Col>
                <Col align={["right", "center"]}>
                    <Button
                        size="small"
                        icon="close"
                        iconColor="error"
                        color="silent"
                        onClick={handleRemoveLink}
                        disabled={!url}
                    >
                        Fjern
                    </Button>
                </Col>
            </Row>
        </div>
    );
};
